import { SiteCommissioningItem } from "../../../../../dtos/siteCommissioning";

export function removeSensor(
    items: Record<string, SiteCommissioningItem>,
    sensorKey: string
): Record<string, SiteCommissioningItem> {
    const next = { ...items };
    delete next[sensorKey];

    Object.entries(next).forEach(([key, item]) => {
        if (key.startsWith("box:") && Array.isArray(item.fields.sensors)) {
            next[key] = {
                fields: { ...item.fields, sensors: (item.fields.sensors as string[]).filter((s) => s !== sensorKey) },
            };
        }
    });

    return next;
}

export function removeIoDevice(
    items: Record<string, SiteCommissioningItem>,
    ioDeviceKey: string
): Record<string, SiteCommissioningItem> {
    let next = { ...items };
    delete next[ioDeviceKey];

    const sensorPrefix = `sensor:${ioDeviceKey}:`;
    Object.keys(next)
        .filter((key) => key.startsWith(sensorPrefix))
        .forEach((sensorKey) => {
            next = removeSensor(next, sensorKey);
        });

    return next;
}

export function removeBox(
    items: Record<string, SiteCommissioningItem>,
    boxKey: string
): Record<string, SiteCommissioningItem> {
    const next = { ...items };
    delete next[boxKey];
    return next;
}

export function splitTopologyItems(items: Record<string, SiteCommissioningItem>): {
    ioDeviceItems: Record<string, SiteCommissioningItem>;
    boxItems: Record<string, SiteCommissioningItem>;
} {
    const ioDeviceItems: Record<string, SiteCommissioningItem> = {};
    const boxItems: Record<string, SiteCommissioningItem> = {};

    Object.entries(items).forEach(([key, item]) => {
        if (key.startsWith("box:")) {
            boxItems[key] = item;
        } else if (key.startsWith("sensor:") || key.startsWith("ioDevice:")) {
            ioDeviceItems[key] = item;
        }
    });

    return { ioDeviceItems, boxItems };
}
